import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ImageChatMessageService } from '@examdojo/chat';
import { assertNonNullable } from '@examdojo/core/util/assert';
import { isNotNullish } from '@examdojo/core/util/nullish';
import { ReviewItemQuery } from '@examdojo/review';
import { UserQuery } from '@examdojo/user';
import { distinctUntilChanged, filter, switchMap } from 'rxjs';

@Injectable()
export class ReviewItemImageChatEffectService {
  constructor(
    private readonly imageChatMessageService: ImageChatMessageService,
    private readonly reviewItemQuery: ReviewItemQuery,
    private readonly userQuery: UserQuery,
  ) {
    this.fetchReviewItemImageChats().pipe(takeUntilDestroyed()).subscribe();
  }

  private fetchReviewItemImageChats() {
    return this.reviewItemQuery.selectActiveId().pipe(
      filter(isNotNullish),
      distinctUntilChanged(),
      switchMap((reviewItemId) => {
        const userId = this.userQuery.getActiveId();
        assertNonNullable(userId, 'User ID not found');

        return this.imageChatMessageService.fetchReviewImageChats(reviewItemId, userId);
      }),
    );
  }
}
